import * as React from 'react';
import { Moment } from '~/types';
import Field from './Field';
import { CellProps } from './CellProps';
import { TextField } from '~/components';
import { time } from '~/utils';

const ListDateTimeField = (props: CellProps<Moment>) => {
  const { children } = props;
  const created = time(children);

  return (
    <Field {...props}>
      <TextField compact label={created.format('LL')}>
        {created.format('LT')}
      </TextField>
    </Field>
  );
};

export default ListDateTimeField;
